<template>
  <v-card class="drop-progress">
    <v-subheader>
      <v-icon medium color="warning" class="mr-2">star</v-icon>
      <span class="ml-2">Провел лучшее ревью для <a :href="userProfileBaseUrl + '/u/' + examinee.uid" target="_blank">{{ examinee.name }} {{ examinee.surname }}</a></span>
    </v-subheader>
  </v-card>
</template>

<script>
import {urls} from "@/config";

export default {
  name: "BestReviewer",
  props: ["examinee"],
  data () {
    return {
      userProfileBaseUrl: urls.signin
    }
  }
}
</script>

<style scoped>
.drop-progress {
  border: 1px solid #78909C;
}

</style>
